<template>
  <div>
    <div
      v-if="activityInfo"
      :class="['pullNewHelp', { inApp: $root.$data.isApp }]"
      :style="{ background: 'url(' + activityInfo.activityBackgroundPicture + ') repeat' }"
    >
      <CommonTitle :titleName="activityInfo.activityName"/>
      <Banner :activityInfo="activityInfo"/>
      <Rule :activityRule="activityInfo.activityRule"/>

      <div>
        <Btn
          v-if="!activityInfo.isAssistanceSuccess && !userInfo.id"
          :title="activityInfo.pullNewType === 0 ? '一键帮好友助力～' : '领取课程，帮好友助力~'"
          @click.native="goToHelp"
        />
        <Btn v-else title="我也要参与活动" @click.native="goToHome"/>
      </div>
      <CoursePull v-if="productId" :productId="productId" type="help" :helpStatus="helpStatus"/>
      <Recommend :activityId="activityId"/>
      <AppDown/>

      <van-popup
        v-model="statusPopup"
        class="statusPopup"
        :duration="0"
        :close-on-click-overlay="helpStatus === 1 || helpStatus === 3 ? false : true"
      >
        <div class="statusContent" :class="{ success: helpStatus === 1 || helpStatus === 3 }">
          <img
            class="helpStatus"
            :src="helpStatus === 1 ? successBg : helpStatus === 3 ? failBg1 : failBg"
            alt=""
          />
          <img class="close" v-if="!(helpStatus === 1 || helpStatus === 3)" @click="statusPopup = false" :src="close"
               alt=""/>
          <p class="tips">
            {{
              helpStatus === 1
                ? '太棒啦，快来一起参与活动吧～'
                : helpStatus === 2
                ? '当前助力用户和分享用户是同一用户'
                : '话不多说，先去参与活动吧～'
            }}
          </p>
          <ExamSeason
            @closeRegisterAfter="closeRegisterAfter"
            v-show="helpStatus === 1 || helpStatus === 3"
          />
        </div>
      </van-popup>
      <van-popup
        v-model="courseSuccessPopup"
        class="courseSuccessPopup"
        :duration="0"
        :close-on-click-overlay="false"
        :closeable="false"
      >
        <h5>温馨提示</h5>
        <p>助力成功！领取到了课程呦~</p>
        <ExamSeason @closeRegisterAfter="closeRegisterAfter"/>
        <div class="info">
          <img class="groupImg" v-if="helpSuccessData.qrcode" :src="helpSuccessData.qrcode" alt=""/>
          <div
            class="slogan"
            v-if="helpSuccessData.slogan"
            v-html="helpSuccessData.slogan.replace(/\n/g, '<br>')"
          ></div>
        </div>
        <!-- <button @click="goToCourse">查看课程</button> -->
      </van-popup>
    </div>
    <van-popup
      v-model="showNc"
      :close-on-click-overlay="false"
      :closeable="false"
      :show-confirm-button="false"
      :lazy-render="false"
      cancel-button-text="取消"
    >
      <div class="nc-box">
        <p class="nc-desc">完成滑动验证方可助力成功！</p>
        <div class="nc-content-box">
          <div id="nc"></div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import { getAssistanceInfoApi, assistanceApi, newAssistanceApi } from '@/api/pullNew';
// eslint-disable-next-line import/no-cycle
import { reqIsBuyProduct } from '@/api/courseDetail';
import { mapState } from 'vuex';
import CommonTitle from '@/components/header/CommonTitle.vue';
import { Dialog } from 'vant';
import wx from 'weixin-js-sdk';
import loadJS from 'load-js';
import Banner from '../components/banner.vue';
import Rule from '../components/rule.vue';
import Btn from '../components/btn.vue';
import CoursePull from '../components/coursePull.vue';
import AppDown from '../components/appDown.vue';
import Recommend from '../components/recommends.vue';
import ExamSeason from '../components/examSeason.vue';

export default {
  components: {
    CommonTitle,
    Banner,
    Rule,
    Btn,
    CoursePull,
    AppDown,
    Recommend,
    ExamSeason,
  },
  data() {
    return {
      activityId: null,
      encryptionKey: null,
      activityInfo: null,
      showNc: false,
      helpStatus: null, // 1 助力成功 2 自己不能给自己助力 3 助力失败
      statusPopup: false, // 助力状态弹窗
      courseSuccessPopup: false, // 仅课程拉新成功时弹出
      successBg: require('@/assets/img/pullNew/success.png'),
      failBg: require('@/assets/img/pullNew/fail.png'),
      failBg1: require('@/assets/img/pullNew/fail1.png'),
      close: require('@/assets/img/pullNew/helpClose.png'),
      pullNewType: 0, // 拉新类型 0 注册拉新 1 课程拉新
      productId: null, // 课程ID
      helpSuccessData: {}, // 仅针对课程拉新用
      ncSuccessData: {}, // 滑块成功回调
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    // 滑动验证
    async pageNcActions() {
      try {
        const that = this;
        const nc_token = ['FFFF0N0000000000ACF9', (new Date()).getTime(), Math.random()].join(':');
        const nc = NoCaptcha.init({
          renderTo: '#nc',
          appkey: 'FFFF0N0000000000ACF9',
          scene: 'nc_activity_h5',
          token: nc_token,
          trans: { key1: 'code200' },
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          timeout: 10000,
          retryTimes: 5,
          errorTimes: 5,
          inline: false,
          bannerHidden: false,
          initHidden: false,
          callback(data) {
            that.ncSuccessData = {
              sessionId: data.csessionid,
              sig: data.sig,
              token: nc_token,
            };
            that.assistance();
          },
          error(s) {},
        });
        NoCaptcha.setEnabled(true);
        nc.reset(); // 请务必确保这里调用一次reset()方法
        NoCaptcha.upLang('cn', {
          LOADING: '加载中...', // 加载
          SLIDER_LABEL: '请向右滑动验证', // 等待滑动
          CHECK_Y: '验证通过', // 通过
          ERROR_TITLE: '非常抱歉，这出错了...', // 拦截
          CHECK_N: '验证未通过', // 准备唤醒二次验证
          OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', // 二次验证
          TIPS_TITLE: '验证码错误，请重新输入', // 验证码输错时的提示
        });
      } catch (err) {
        console.log('err', err);
      }
    },
    async getActivityInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const info = await getAssistanceInfoApi({
        activityId: this.activityId,
        encryptionKey: this.encryptionKey,
      });
      this.$toast.clear();
      const { code, data, msg } = info;
      if (code === 0) {
        this.activityInfo = data;
        const { isAssistanceSuccess, pullNewType = 0, productId } = data;
        if (this.$root.$data.isApp) document.title = data.activityName;
        this.pullNewType = pullNewType;
        this.productId = productId;
        const { activityId, activityPicture, activityName } = data;
        const path = `${window.location.origin}/ark/pullnew/helper/?activityId=${activityId}`;
        this.wxInit(path, activityName, activityPicture);
        if (!isAssistanceSuccess && this.userInfo.id) {
          // 未助力 且登录状态下
          if (!this.userInfo.id) {
            window.location.reload();
            return;
          }
          this.beforeAssistaance();
        }
      } else if (code === 9001 || code === 9002 || code === 9408) {
        // 未开始 已结束
        this.$router.replace({
          path: '/pullnew/over',
          query: {
            activityId: this.activityId,
            activityStatus: code,
          },
        });
      } else {
        this.$toast.fail(msg);
      }
    },
    wxInit(path, title, imageUrl) {
      wx.ready(() => { // 需在用户可能点击分享按钮前就先调用
        wx.miniProgram.postMessage({
          data: {
            path,
            title,
            imageUrl,
          },
        });
      });
    },
    beforeAssistaance() {
      this.showNc = true;
      this.pageNcActions();
    },
    async assistance() {
      // 助力接口
      const { code, data } = await newAssistanceApi({
        activityId: this.activityId,
        encryptionKey: this.encryptionKey,
        sessionId: this.ncSuccessData.sessionId,
        sig: this.ncSuccessData.sig,
        token: this.ncSuccessData.token,
      });
      if (code === 0) {
        this.helpSuccessData = data;
        this.helpStatus = 1;
      } else if (code === 9013) {
        // 自己给自己助力
        this.helpStatus = 2;
      } else if (code === 9014) {
        // 当前分享的活动，已到达最多拉新的人数，助力失败
        this.helpStatus = 3;
      } else {
        this.helpStatus = 4;
      }
      if (this.helpStatus === 1 && this.pullNewType === 1) {
        this.courseSuccessPopup = true;
      } else {
        this.statusPopup = true;
      }
      this.showNc = false;
    },
    goToHelp() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('login');
      } else if (this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        const params = searchParams.split('&');
        const paramsMap = new Map();

        params.forEach((item) => {
          const [key, value] = item.split('=');
          if (key) {
            paramsMap.set(key, value);
          }
        });
        const entries = paramsMap.entries();
        let query = '';
        const ExcludequeryArr = ['THIRD_SESSION', 'env'];
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of entries) {
          if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
        }
        url = `${domain}?${query}`;
        const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
      } else {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
      }
    },
    async goToCourse() {
      const { code, data } = await reqIsBuyProduct(this.productId);
      if (code !== 0 || !data.length) {
        this.$toast.fail('课程发放中，请稍后再试');
        return;
      }
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(this.productId), false);
        return;
      }
      sessionStorage.setItem('back', 'back');
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.productId,
        },
      });
    },
    goToHome() {
      this.$router.push({
        path: '/pullnew/home',
        query: { activityId: this.activityId },
      });
    },
    closeRegisterAfter() {
      this.statusPopup = false;
      this.courseSuccessPopup = false;
    },
  },
  async mounted() {
    this.getActivityInfo();
  },
  created() {
    const { activityId, key } = this.$route.query;
    this.activityId = activityId;
    this.encryptionKey = key;
  },
};
</script>
<style scoped lang="scss">
.nc-box{
  position: relative;
  width: 670px;
  height: 260px;
  padding-top: 50px;
  text-align: center;
  background: #fff;
  .nc-close{
    position: absolute;
    top: 20px;
    right: 30px;
    width: 36px;
    height: 36px;
  }
  .nc-desc{
    font-size: 28px;
    text-align: center;
  }
  .nc-content-box{
    box-sizing: border-box;
    width: 100%;
    margin-top: 48px;
  }
}
.pullNewHelp {
  min-height: 100vh;
  padding: 100px 0;

  &.inApp {
    padding-top: 0;
  }

  .statusPopup {
    background: none;

    .statusContent.success {
      height: 1028px;

      .tips {
        bottom: 550px;
      }
    }

    .statusContent {
      position: relative;
      width: 622px;
      height: 548px;

      .helpStatus {
        position: absolute;
        width: 100%;
        height: 100%;
      }

      .close {
        position: absolute;
        top: 20px;
        right: 0;
        width: 48px;
        height: 48px;
      }

      .tips {
        position: absolute;
        bottom: 70px;
        width: 100%;
        color: #733d08;
        font-size: 28px;
        text-align: center;
      }
    }
  }

  .courseSuccessPopup {
    // display: flex;
    // flex-flow: column;
    // align-items: center;
    // justify-content: space-around;
    width: 622px;
    padding: 50px 0;
    font-size: 28px;
    // max-height: 970px;
    background: linear-gradient(180deg, #fff 0%, #ffe9c6 100%);
    border-radius: 32px;

    h5 {
      color: #333;
      font-size: 36px;
      text-align: center;
    }

    p {
      width: 100%;
      padding: 48px 0 24px 0;
      text-align: center;
      // border-bottom: 2px solid #ebebeb;
    }

    .examSeason {
      position: relative;
      top: 0;
      // top: 300px;
    }

    .info {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      padding: 0 32px;
    }

    .slogan {
      box-sizing: border-box;
      width: 374px;
      margin-left: 10px;
      // margin-top: 32px;
      padding: 0 0 0 24px;
      // overflow-x: scroll;
      color: #333;
    }

    .groupImg {
      width: 160px;
      // height: 160px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 462px;
      height: 88px;
      margin-top: 10px;
      color: #fff;
      background: #ff1a3f;
      border-radius: 44px;
    }
  }

  ::v-deep .van-overlay,
  ::v-deep .van-popup--center {
    z-index: 1000000 !important;
  }
}
</style>
<style>
.sm-pop-inner.nc-container{
  width: 80%;
}
</style>
